/*
 * The ruler estimator. Reads every number from NilyaBinding, so the price shown
 * here and the price quoted anywhere else on the site come from one file.
 *
 * The coil is drawn at the diameter we would actually FIT, not the diameter the
 * block strictly needs — those differ by the round-up to a stocked size, and the
 * gap between the ring and the block is the clearance the coil turns in. Drawing
 * the required diameter while labelling the stocked one was the original bug.
 *
 * Nothing that carries a number is animated.
 */
(function () {
  'use strict';

  var PX_PER_INCH = 130; // drawing units
  var BASE_Y = 310; // the ruler's zero
  var VIEW_BOX = '0 0 620 336';

  /* Eighth-inch ticks up the ruler, with the inch marks pulled out separately. */
  var MINOR_TICKS = [];
  for (var t = 1; t <= 17; t++) {
    var v = t * 0.125;
    if (Math.abs(v % 1) > 0.001) MINOR_TICKS.push(v);
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function ruler(uid, thickness, B) {
    var blockH = Math.max(3, thickness * PX_PER_INCH);
    var blockY = BASE_Y - blockH;
    var coil = B.coilFor(thickness);
    var largest = B.coilSizes[B.coilSizes.length - 1];
    var coilR = (coil || largest).in * PX_PER_INCH * 0.5;
    var midY = blockY + blockH / 2;

    var p = [];
    p.push('<defs><filter id="eb-' + uid + '" x="-40%" y="-40%" width="180%" height="180%">');
    p.push('<feGaussianBlur stdDeviation="5"/></filter></defs>');

    p.push('<line x1="60" y1="' + BASE_Y + '" x2="60" y2="8" stroke="#24374f" stroke-width="2"/>');
    p.push('<g stroke="#8d8272" stroke-width="1.4">');
    for (var i = 0; i < MINOR_TICKS.length; i++) {
      var inches = MINOR_TICKS[i];
      var y = BASE_Y - inches * PX_PER_INCH;
      var x2 = Math.abs(inches % 0.5) < 0.001 ? 80 : 74;
      p.push('<line x1="60" y1="' + y + '" x2="' + x2 + '" y2="' + y + '"/>');
    }
    p.push('</g>');

    p.push('<g stroke="#24374f" stroke-width="2">');
    for (var n = 0; n <= 2; n++) {
      var iy = BASE_Y - n * PX_PER_INCH;
      p.push('<line x1="60" y1="' + iy + '" x2="90" y2="' + iy + '"/>');
    }
    p.push('</g>');

    p.push('<g font-size="13" font-weight="600" fill="#24374f" text-anchor="end">');
    for (var m = 0; m <= 2; m++) {
      p.push('<text x="52" y="' + (BASE_Y - m * PX_PER_INCH + 5) + '">' + m + '&quot;</text>');
    }
    p.push('</g>');

    /* The block, to scale */
    p.push('<rect x="156" y="' + blockY + '" width="272" height="' + blockH + '" fill="#14202f" opacity="0.13" filter="url(#eb-' + uid + ')"/>');
    p.push('<rect x="150" y="' + blockY + '" width="272" height="' + blockH + '" fill="#f7f4ee" stroke="#cdc4b4" stroke-width="1.4"/>');
    p.push('<g stroke="#e4ded2" stroke-width="1">');
    for (var q = 1; q <= 3; q++) {
      var ly = blockY + blockH * (q / 4);
      p.push('<line x1="150" y1="' + ly + '" x2="422" y2="' + ly + '"/>');
    }
    p.push('</g>');

    /* The coil seen end-on, to the same scale as the block it must clear */
    p.push('<circle cx="150" cy="' + midY + '" r="' + coilR + '" fill="none" stroke="#141518" stroke-width="9"/>');
    p.push('<circle cx="150" cy="' + midY + '" r="' + coilR + '" fill="none" stroke="#2f3338" stroke-width="6"/>');
    p.push('<circle cx="150" cy="' + midY + '" r="' + coilR + '" fill="none" stroke="#5b626a" stroke-width="2.6"/>');

    /* The measurement, called out */
    p.push('<line x1="470" y1="' + blockY + '" x2="470" y2="' + BASE_Y + '" stroke="#9c2f2a" stroke-width="1.6"/>');
    p.push('<line x1="464" y1="' + blockY + '" x2="476" y2="' + blockY + '" stroke="#9c2f2a" stroke-width="1.6"/>');
    p.push('<line x1="464" y1="' + BASE_Y + '" x2="476" y2="' + BASE_Y + '" stroke="#9c2f2a" stroke-width="1.6"/>');
    p.push('<text x="486" y="' + (midY + 2) + '" font-size="30" fill="#14202f" font-family="Newsreader, Georgia, serif">' + thickness.toFixed(2) + '&quot;</text>');
    p.push('<text x="486" y="' + (midY + 22) + '" font-size="13" fill="#5a6875">measured at the spine</text>');

    return p.join('');
  }

  function row(label, value) {
    return (
      '<div class="nilya-est__row"><dt>' + esc(label) + '</dt><dd>' + esc(value) + '</dd></div>'
    );
  }

  function setup(host) {
    if (host.dataset.ready === '1') return;
    var B = window.NilyaBinding;
    if (!B) return;
    host.dataset.ready = '1';

    var uid = 'est' + Math.random().toString(36).slice(2, 7);
    var drawing = host.querySelector('[data-drawing]');
    var range = host.querySelector('[data-thickness]');
    var qtyGroup = host.querySelector('[data-qty-group]');
    var qtyNote = host.querySelector('[data-qty-note]');
    var optionsBox = host.querySelector('[data-options]');
    var result = host.querySelector('[data-result]');
    var coilOut = host.querySelector('[data-coil]');
    var breakdown = host.querySelector('[data-breakdown]');

    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', VIEW_BOX);
    svg.setAttribute('role', 'img');
    svg.setAttribute('class', 'nilya-est__svg');
    drawing.insertBefore(svg, drawing.firstChild);

    /* Finishing options are built from the price file rather than written into
       the Liquid, so adding one there adds it here with its price attached. */
    var checkboxes = [];
    for (var o = 0; o < B.options.length; o++) {
      var opt = B.options[o];
      var wrap = document.createElement('div');
      wrap.className = 'nilya-est__option';
      var id = 'nilya-opt-' + opt.id;
      wrap.innerHTML =
        '<input type="checkbox" id="' + id + '" value="' + opt.id + '">' +
        '<label for="' + id + '">' + esc(opt.label) +
        ' <span>— +' + B.money(opt.price) + ' each</span></label>';
      optionsBox.appendChild(wrap);
      checkboxes.push(wrap.querySelector('input'));
    }

    var qty = 1;

    function chosen() {
      var out = [];
      for (var c = 0; c < checkboxes.length; c++) {
        if (checkboxes[c].checked) out.push(checkboxes[c].value);
      }
      return out;
    }

    function render() {
      var thickness = Number(range.value) / 100;
      var picked = chosen();
      var r = B.quote(thickness, qty, picked);

      svg.innerHTML = ruler(uid, thickness, B);
      svg.setAttribute(
        'aria-label',
        'A ruler marked in inches with a book block ' + thickness.toFixed(2) +
          ' inches thick beside it, and the coil that fits it drawn to the same scale.'
      );

      coilOut.textContent = r.bindable ? r.coilLabel + ' · ' + r.coilMm + ' mm' : 'Too thick to coil';
      result.classList.toggle('is-bindable', r.bindable);

      qtyNote.textContent =
        r.discountRate > 0
          ? Math.round(r.discountRate * 100) + '% off the binding on ' + qty + ' books, one label for the lot.'
          : 'Single copies are the normal job here — no minimum, no surcharge.';

      if (!r.bindable) {
        /* No breakdown when we cannot do the job: a price list for a book we are
           turning away only reads as confusion. Say why, and what next. */
        breakdown.innerHTML =
          '<div class="nilya-est__refuse">' +
          '<p>This block is thicker than 1⅞&quot; — the largest coil we stock, less the clearance it needs to turn. A coil sized to it would bind against the pages every time you turned one.</p>' +
          '<p>Send us a photo anyway. A book this size usually wants Wire-O or a sewn rebind, and we will tell you who does that well.</p>' +
          '</div>';
        return;
      }

      var rows = '';
      rows += row('Binding, ' + qty + (qty === 1 ? ' book at ' : ' books at ') + B.money(r.bindEach), B.money(r.bindTotal));
      rows += row(
        r.optionsEach > 0 ? 'Finishing at ' + B.money(r.optionsEach) + ' each' : 'Finishing — none chosen',
        B.money(r.optionsTotal)
      );
      rows += row(
        r.discountRate > 0 ? 'Volume, ' + Math.round(r.discountRate * 100) + '% off' : 'Volume discount from 2 books',
        r.discount > 0 ? '−' + B.money(r.discount) : B.money(0)
      );
      rows += row('Return shipping, tracked', B.money(r.shipping));

      breakdown.innerHTML =
        '<dl class="nilya-est__rows">' + rows + '</dl>' +
        '<div class="nilya-est__total">' +
        '<div class="nilya-est__total-label"><div>Total, bound and back in your hands</div><div>' +
        B.money(r.perBook) + ' a book</div></div>' +
        '<div class="nilya-est__total-value">' + B.money(r.total) + '</div>' +
        '</div>';
    }

    range.addEventListener('input', render);
    for (var cb = 0; cb < checkboxes.length; cb++) {
      checkboxes[cb].addEventListener('change', render);
    }
    qtyGroup.addEventListener('click', function (event) {
      var button = event.target.closest('[data-qty]');
      if (!button) return;
      qty = Number(button.dataset.qty);
      var all = qtyGroup.querySelectorAll('[data-qty]');
      for (var a = 0; a < all.length; a++) {
        var on = all[a] === button;
        all[a].classList.toggle('is-on', on);
        all[a].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      render();
    });

    render();
  }

  function init() {
    var hosts = document.querySelectorAll('[data-nilya-estimator]');
    for (var i = 0; i < hosts.length; i++) setup(hosts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
